/* MT Sports v35 - personalizacao e selos de produto */
(function () {
  "use strict";

  if (window.__mtPersonalizacaoDefaultInitialized) return;
  window.__mtPersonalizacaoDefaultInitialized = true;

  function norm(v) {
    try {
      return String(v || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();
    } catch (e) {
      return String(v || "")
        .trim()
        .toLowerCase();
    }
  }
  function css() {
    if (document.getElementById("mt-v35-style")) return;
    var s = document.createElement("style");
    s.id = "mt-v35-style";
    s.textContent =
      '.mt-custom-fields-v35{display:none!important;margin:16px 0;padding:14px;border:1px solid rgba(255,255,255,.32);border-radius:7px;background:#111;color:#fff}.mt-custom-fields-v35.is-visible{display:grid;grid-template-columns:1fr 120px;gap:10px}.mt-custom-fields-v35 label{display:block;margin:0 0 6px;font-size:12px;font-weight:800;color:#fff;text-transform:uppercase}.mt-custom-fields-v35 input{display:block!important;width:100%!important;height:44px!important;padding:0 12px!important;border:1px solid #ccc!important;border-radius:5px!important;background:#fff!important;color:#111!important;-webkit-text-fill-color:#111!important}.product-item__image-wrapper{position:relative!important}.mt-card-stock-v35{position:absolute;z-index:4;top:12px;left:12px;padding:8px 12px;border-radius:2px;background:#12151a;color:#fff;font-size:11px;line-height:1;font-weight:900;letter-spacing:.06em;text-transform:uppercase;box-shadow:0 2px 8px rgba(0,0,0,.25)}.mt-card-stock-v35--imported{background:#12151a}.mt-card__image{position:relative!important}.mt-card__stock{position:absolute!important;z-index:5!important;top:12px!important;left:12px!important;padding:8px 12px!important;background:#12151a!important;color:#fff!important;font-size:11px!important;line-height:1!important;font-weight:900!important;letter-spacing:.06em!important;text-transform:uppercase!important}.mt-card__promo{display:grid!important;grid-template-columns:auto 1fr!important;align-items:center!important;gap:12px!important;width:100%!important;min-height:44px!important;margin-top:14px!important;padding:10px 14px!important;border:1px solid rgba(255,255,255,.34)!important;border-radius:5px!important;background:#11151b!important;color:#fff!important}.mt-card__promo span,.mt-card__promo strong{color:#fff!important;font-size:11px!important;font-weight:900!important}.mt-card-promo-v35{display:flex;align-items:center;gap:5px;width:100%;min-height:39px;margin-top:12px;padding:8px 11px;border:1px solid rgba(255,255,255,.34);border-radius:5px;background:#11151b!important;color:#fff;font-size:11px;font-weight:900;letter-spacing:.035em;text-transform:uppercase}.mt-card-promo-v35:before{content:"MT •";font-weight:1000}.mt-product-badge--imported{display:none!important}.mt-card .mt-product-badges,.mt-card .mt-product-badge--promo,.mt-card .mt-v35-hide,.product-item .mt-product-badges,.product-item .mt-product-badge--promo,.product-item .mt-v35-hide{display:none!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;border:0!important;overflow:hidden!important}.mt-product-badges{display:block!important}.mt-product-badge--promo{display:block!important;width:100%!important;padding:10px 13px!important;border:1px solid rgba(255,255,255,.34)!important;border-radius:5px!important;background:#11151b!important;color:#fff!important;font-size:12px!important;line-height:1.2!important;font-weight:950!important;letter-spacing:.025em!important;text-align:center!important}.mt-shipping-note-v36{display:flex;align-items:flex-start;gap:8px;margin:12px 0 4px;padding:9px 11px;border:1px solid rgba(255,255,255,.22);border-radius:5px;background:#11151b;color:#fff;font-size:11px;line-height:1.35}.mt-shipping-note-v36 strong{color:#fff;font-size:11px}.mt-shipping-note-v36 span{color:#d7dbe2}.mt-v35-hide{display:none!important}@media(max-width:520px){.mt-custom-fields-v35.is-visible{grid-template-columns:1fr}.mt-card-stock-v35{top:8px;left:8px;padding:7px 9px;font-size:9px}.mt-card-promo-v35{font-size:9px;padding:7px 8px}}';
    document.head.appendChild(s);
  }
  function personalGroups(root) {
    var sc = root && root.querySelectorAll ? root : document;
    return [].slice
      .call(sc.querySelectorAll(".product-form__option"))
      .filter(function (g) {
        var name = g.querySelector(".product-form__option-name");
        return (
          norm((name ? name.textContent : "") + " " + g.textContent).indexOf(
            "personalizar",
          ) > -1
        );
      });
  }
  function selectedPersonal(g) {
    var x = g.querySelector("input:checked,select");
    return (
      x &&
      ["personalizar", "sim", "com personalizacao"].indexOf(norm(x.value)) > -1
    );
  }
  function ensureFields(g) {
    var form = g.closest("form");
    if (!form) return;
    [].slice
      .call(form.querySelectorAll(".mt-custom-fields-v35"))
      .forEach(function (x) {
        x.remove();
      });
    var radios = [].slice.call(
      g.querySelectorAll('input[type="radio"],input[type="checkbox"]'),
    );
    radios.forEach(function (r) {
      var n = norm(r.value);
      var lab = r.id
        ? g.querySelector('label[for="' + r.id.replace(/"/g, '\\\"') + '"]')
        : null;
      if (
        lab &&
        (n === "nao" ||
          n === "nao personalizar" ||
          n === "sem personalizacao" ||
          n === "sem personalizar")
      ) {
        var tx = lab.querySelector(".block-swatch__item-text") || lab;
        tx.textContent = "Não";
      } else if (
        lab &&
        (n === "personalizar" || n === "sim" || n === "com personalizacao")
      ) {
        var tx2 = lab.querySelector(".block-swatch__item-text") || lab;
        tx2.textContent = "Personalizar";
      }
    });
    var box =
      form.querySelector("#mt-legacy-personalizacao-v36") ||
      form.querySelector(".line-item-property__field");
    if (!box) {
      box = document.createElement("p");
      box.id = "mt-legacy-personalizacao-v36";
      box.className = "line-item-property__field mt-personalizacao-box";
      box.innerHTML =
        '<label for="campo-personalizacao-nome" class="align-label-campo"><span>👤 Nome:</span></label><input id="campo-personalizacao-nome" placeholder="Ex: Carlos S." type="text" name="properties[Nome]"><label for="campo-personalizacao-numero" class="align-label-campo" style="margin-top:8px"><span>⚽ Número:</span><span class="aviso"> (máximo 3 caracteres)</span></label><input id="campo-personalizacao-numero" placeholder="Ex: 10" type="text" maxlength="3" name="properties[Número]">';
      g.insertAdjacentElement("afterend", box);
    }
    var on = selectedPersonal(g);
    box.classList.add("mt-personalizacao-box");
    box.classList.toggle("is-visible", !!on);
    box.setAttribute("aria-hidden", on ? "false" : "true");
    box.style.setProperty("display", on ? "block" : "none", "important");
    box.style.setProperty("visibility", on ? "visible" : "hidden", "important");
    box.style.setProperty("opacity", on ? "1" : "0", "important");
    box.style.setProperty("max-height", on ? "600px" : "0", "important");
    box.style.setProperty("overflow", on ? "visible" : "hidden", "important");
    box.style.setProperty("pointer-events", on ? "auto" : "none", "important");
    [].slice
      .call(box.querySelectorAll("input,select,textarea"))
      .forEach(function (el) {
        el.disabled = !on;
        if (!on && (el.tagName === "INPUT" || el.tagName === "TEXTAREA"))
          el.value = "";
      });
  }
  function initPersonal(root) {
    personalGroups(root).forEach(ensureFields);
  }
  function leafElements(card) {
    return [].slice
      .call(card.querySelectorAll("div,span,p,strong"))
      .filter(function (e) {
        return e.children.length === 0;
      });
  }
  function cleanOldCardBadges(card) {
    leafElements(card).forEach(function (e) {
      var t = norm(e.textContent);
      if (
        t === "produto importado" ||
        t.indexOf("brinde torcedor") > -1 ||
        t.indexOf("3a camisa torcedor") > -1
      ) {
        var target = e;
        if (
          e.parentElement &&
          e.parentElement !== card &&
          e.parentElement.children.length === 1
        )
          target = e.parentElement;
        target.classList.add("mt-v35-hide");
      }
    });
  }
  function eligible(title) {
    var t = norm(title);
    return (
      t.indexOf("camisa") > -1 &&
      t.indexOf("pronta entrega") < 0 &&
      t.indexOf("kit infantil") < 0 &&
      t.indexOf("kit de inverno") < 0 &&
      t.indexOf("regata") < 0 &&
      t.indexOf("nba") < 0 &&
      t.indexOf("conjunto") < 0 &&
      t.indexOf("tenis") < 0 &&
      t.indexOf("shoe") < 0 &&
      t.indexOf("sneaker") < 0
    );
  }
  function cardTitle(card) {
    var e = card.querySelector(".product-item__title");
    return e ? e.textContent : "";
  }
  function initCards(root) {
    var sc = root && root.querySelectorAll ? root : document;
    [].slice
      .call(sc.querySelectorAll(".product-item"))
      .forEach(function (card) {
        var title = cardTitle(card),
          nt = norm(title),
          ready =
            nt.indexOf("pronta entrega") > -1 ||
            [].slice
              .call(card.querySelectorAll(".product-label"))
              .some(function (x) {
                return norm(x.textContent) === "pronta entrega";
              });
        var hasStandard = [].slice
          .call(card.querySelectorAll("div,span,p,strong"))
          .some(function (x) {
            var t = norm(x.textContent);
            return (
              t.indexOf("leve 3") > -1 &&
              t.indexOf("pague 2") > -1 &&
              t.indexOf("brinde") < 0 &&
              t.indexOf("camisa torcedor") < 0
            );
          });
        cleanOldCardBadges(card);
        var image = card.querySelector(".product-item__image-wrapper");
        if (
          image &&
          !ready &&
          nt.indexOf("tenis") < 0 &&
          !image.querySelector(".mt-card-stock-v35")
        ) {
          var badge = document.createElement("span");
          badge.className = "mt-card-stock-v35 mt-card-stock-v35--imported";
          badge.textContent = "PRODUTO IMPORTADO";
          image.appendChild(badge);
        }
        var info =
          card.querySelector(".product-item__info-inner") ||
          card.querySelector(".product-item__info");
        if (
          info &&
          eligible(title) &&
          !ready &&
          !hasStandard &&
          !info.querySelector(".mt-card-promo-v35")
        ) {
          var promo = document.createElement("div");
          promo.className = "mt-card-promo-v35";
          promo.textContent = "LEVE 3, PAGUE 2";
          info.appendChild(promo);
        }
      });
  }
  function initHomeCards(root) {
    var sc = root && root.querySelectorAll ? root : document;
    [].slice.call(sc.querySelectorAll(".mt-card")).forEach(function (card) {
      var titleEl = card.querySelector("h3"),
        title = norm(titleEl ? titleEl.textContent : "");
      var ready = title.indexOf("pronta entrega") > -1;
      var shirt =
        title.indexOf("camisa") > -1 &&
        title.indexOf("kit infantil") < 0 &&
        title.indexOf("kit de inverno") < 0 &&
        title.indexOf("regata") < 0 &&
        title.indexOf("nba") < 0 &&
        title.indexOf("tenis") < 0;
      var image = card.querySelector(".mt-card__image");
      var stock = card.querySelector(".mt-card__stock");
      if (image) {
        if (ready) {
          if (!stock) {
            stock = document.createElement("span");
            stock.className = "mt-card__stock";
            image.appendChild(stock);
          }
          stock.textContent = "PRONTA ENTREGA";
        } else if (stock) {
          stock.remove();
        }
      }
      var old = card.querySelector(".mt-product-badges");
      if (old) old.classList.add("mt-v35-hide");
      var promo = card.querySelector(".mt-card__promo");
      if (ready || !shirt) {
        if (promo) promo.remove();
        return;
      }
      if (!promo) {
        promo = document.createElement("div");
        promo.className = "mt-card__promo";
        var body = card.querySelector(".mt-card__body");
        if (body) body.appendChild(promo);
      }
      if (promo) {
        promo.setAttribute("aria-label", "Leve 3, pague 2 MT");
        promo.innerHTML = "<span>MT</span><strong>LEVE 3, PAGUE 2</strong>";
      }
    });
  }
  function productShipping() {
    if (!document.body.classList.contains("template-product")) return;
    var old = document.querySelector(".mt-shipping-note-v36");
    if (old) return;
    var h = document.querySelector("h1");
    var title = norm(h ? h.textContent : "");
    if (title.indexOf("tenis") > -1) return;
    var ready = title.indexOf("pronta entrega") > -1;
    var note = document.createElement("div");
    note.className = "mt-shipping-note-v36";
    note.innerHTML = ready
      ? "<strong>FRETE GRÁTIS</strong><span>Produto à pronta entrega.</span>"
      : "<strong>FRETE GRÁTIS</strong><span>Produto importado: pode haver tributação. Se ocorrer, a MT Sports ajuda com 20% do valor da taxa, mediante comprovante.</span>";
    var anchor =
      document.querySelector(".product-form__option") ||
      document.querySelector(".product-form");
    if (anchor) anchor.parentNode.insertBefore(note, anchor);
  }
  function productPromo() {
    var p = document.querySelector(
      "body.template-product .mt-product-badge--promo",
    );
    if (p) p.textContent = "MT • LEVE 3, PAGUE 2";
  }
  function apply(root) {
    css();
    initPersonal(root);
    initCards(root);
    initHomeCards(root);
    productPromo();
    productShipping();
  }
  function init() {
    apply(document);
    document.addEventListener(
      "change",
      function (e) {
        var g =
          e.target &&
          e.target.closest &&
          e.target.closest(".product-form__option");
        if (g) ensureFields(g);
      },
      true,
    );
    document.addEventListener(
      "click",
      function (e) {
        var g =
          e.target &&
          e.target.closest &&
          e.target.closest(".product-form__option");
        if (g)
          setTimeout(function () {
            ensureFields(g);
          }, 0);
      },
      true,
    );
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        [].slice.call(m.addedNodes).forEach(function (n) {
          if (n && n.nodeType === 1) apply(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
    [80, 250, 700, 1500].forEach(function (ms) {
      setTimeout(function () {
        apply(document);
      }, ms);
    });
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", function (e) {
    apply(e.target || document);
  });
})();
